import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Button from "../../../componentes/button/button";
import CargaEntregaService from "../../../services/resource/escalaDeRotaService";
import DropDown from "../../../componentes/dropdown/dropdown";
import { useAuth } from "../../../context/authContext";
import Input from "../../../componentes/input/input";
import Multiselect from "../../../componentes/multiselect/multiselect";
import ButtonRadio from "../../../componentes/button-radio/button-radio";
import { Dialog } from "primereact/dialog";
import Textarea from "../../../componentes/input/textarea";

const initialValues = {
    "id": "",
    "carga": "",
    "data": null,
    "cracha": "",
    "transporte": "",
    "area": "",
    "totalEntregas": null,
    "volume": null,
    "cubos": null,
    "capCubos": null,
    "distanciaPlanejada": null,
    "ocupacao": null,
    "tempoTotal": null,
    "motoristaId": "",
    "veiculoId": null,
    "auxiliares": [
        {
            "id": "",
            "nome": "",
            "filialId": null,
            "filialNome": ""
        }
    ],
    "filialId": null,
    "filialNome": ""

}

function EditarEscalaRota({ carga, onClose, onCloseDelete, onDataAlterada, auxiliares, motoristas, veiculos, filiais, idFilial }) {
    const cargaService = new CargaEntregaService();
    const { user } = useAuth();

    const [form, setForm] = useState(initialValues);
    const [textoParaExcluir, setTextoParaExcluir] = useState(null);
    const [showDialogDelete, setShowDialogDelete] = useState(false);
    const [filialId, setFilialId] = useState(idFilial);
    const [loading, setLoading] = useState(false);
    const [showDialogData, setShowDialogData] = useState(false);
    const [novaDataOperacao, setNovaDataOperacao] = useState("");
    const [salvandoData, setSalvandoData] = useState(false);
    const [erros, setErros] = useState({
        motorista: false,
        auxiliares: false,
        veiculo: false
    })

    useEffect(() => {
        document.title = "MyDash | Planejamento"

    }, []);

    useEffect(() => {
        if (!carga) return;

        setForm(carga);

    }, [carga]);

    useEffect(() => {
        if (form.veiculoId) {
            const data = {
                dataOperacao: carga.dataOperacao,
                cargaId: carga.id,
                veiculoId: form.veiculoId
            };

            cargaService.validaVeiculo(data).then(res => {
                setErr('veiculo', res.data)
            });

        }
    }, [form.veiculoId])

    useEffect(() => {
        if (form.auxiliares.length >= 1) {

            const promises = form.auxiliares.map(aux => {
                const data = {
                    dataOperacao: carga.dataOperacao,
                    cargaId: carga.id,
                    auxiliarId: aux.id
                };

                return cargaService.validadAuxiliar(data);
            });

            Promise.all(promises).then(results => {
                const temErro = results.some(res => res.data === true);
                setErr('auxiliares', temErro);
            });

        } else {
            setErr('auxiliares', false);
        }

    }, [form.auxiliares]);

    useEffect(() => {
        if (form.motoristaId) {
            const data = {
                dataOperacao: carga.dataOperacao,
                cargaId: carga.id,
                motoristaId: form.motoristaId
            };

            cargaService.validaMotorista(data).then(res => {
                setErr('motorista', res.data)
            });
        }
    }, [form.motoristaId])

    const handleSalvar = async () => {
        setLoading(true);

        try {
            const response = await cargaService.atualizarCarga(carga?.id, form);

            toast.success("Atualizado com sucesso!");
            onClose(response.data);

        } catch {
            console.error("Erro ao salvar.");
        } finally {
            setLoading(false);
        }
    };

    const setCampo = (campo, valor) => {
        setForm(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const setErr = (campo, valor) => {
        setErros(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const excluirCarga = () => {
        cargaService.excluirCarga(carga?.id).then(() => {
            setShowDialogDelete(false);
            onCloseDelete(carga)
            toast.success("Carga Removida com Sucesso!");
        }).catch(e => console.error(e))
    };

    const abrirAlterarData = () => {
        setNovaDataOperacao(carga?.dataOperacao ?? "");
        setShowDialogData(true);
    };

    // Endpoint específico: só o dia de operação muda. Carga repetida no dia e comissão fechada são barradas no backend.
    const confirmarAlteracaoData = async () => {
        if (!novaDataOperacao) {
            toast.error("Informe a nova data de operação.");
            return;
        }
        if (novaDataOperacao === carga.dataOperacao) {
            setShowDialogData(false);
            return;
        }

        setSalvandoData(true);
        try {
            const response = await cargaService.atualizarDataOperacao(carga.id, novaDataOperacao);

            toast.success("Data de operação alterada. Gere a comissão novamente para as competências afetadas.");
            setShowDialogData(false);
            onDataAlterada?.(response.data);
        } catch (e) {
            console.error(e);
        } finally {
            setSalvandoData(false);
        }
    };

    const onCloseModalDelete = () => {
        setShowDialogDelete(false);
        setTextoParaExcluir(null);
    }

    return (
        <div className="flex flex-col gap-5 pt-2 w-full">
            <div className="p-1 grid grid-cols-2 md:grid-cols-6 gap-3">
                <DropDown
                    label="Filial"
                    optional
                    className="w-full text-xs border"
                    optionLabel="nome"
                    optionValue="id"
                    name="filialId"
                    disabled={user.perfis.includes('COMISSOES')}
                    options={filiais}
                    value={filialId}
                    filter={false}
                    onChange={e => setFilialId(e.value)}
                />

                <Input
                    label="Carga"
                    value={form.carga}
                    onChange={e => setCampo("carga", e.target.value)}
                />

                <div className="md:col-span-2">
                    <DropDown
                        label="Veículo"
                        value={form.veiculoId}
                        options={veiculos}
                        itemTemplate={(item) => <div>
                            {item.placa} <span className="text-muted-foreground text-xs">{item.codigoYork}</span>  <span className="text-muted-foreground text-xs">{item.codigoSolar}</span>
                        </div>
                        }
                        optionValue="id"
                        optionLabel="placa"
                        nullValue
                        filter
                        onChange={(e) => setCampo("veiculoId", e.target.value)}
                        showClear
                        touched={true}
                        placeholder="Selecione o veículo"
                        error={erros.veiculo === true ? "Veículo Vinculado em Outra Carga" : null}
                    />
                </div>

                <Input
                    label="Cracha"
                    value={form.cracha}
                    onChange={e => setCampo("cracha", e.target.value)}
                />

                <Input
                    label="Transporte"
                    value={form.transporte}
                    onChange={e => setCampo("transporte", e.target.value)}
                />

                <div className="md:col-span-2">
                    <DropDown
                        label="Motorista"
                        value={form.motoristaId}
                        options={motoristas}
                        optionValue="id"
                        optionLabel="nome"
                        itemTemplate={(item) => <div className={`text-xs ${item.ativo === false && 'text-destructive'}`}>
                            {item.nome} <span className="text-muted-foreground text-xs">{item.codigo} ({item.cargo})</span>
                        </div>
                        }
                        nullValue
                        filter
                        onChange={(e) => setCampo("motoristaId", e.target.value)}
                        placeholder="Selecione o motorista"
                        showClear
                        touched={true}
                        error={erros.motorista === true ? "Motorista Vinculado em Outra Carga" : null}
                    />
                </div>

                <div className="md:col-span-4">
                    <Multiselect
                        value={form.auxiliares}
                        label="Auxiliares"
                        options={auxiliares}
                        optionLabel="nome"
                        onChange={(e) => setCampo('auxiliares', e.value)}
                        itemTemplate={(item) =>  <div className={`text-xs ${item.ativo === false && 'text-destructive'}`}>
                            {item.nome} <span className="text-muted-foreground text-xs">{item.codigo}</span>
                        </div>
                        }
                        multiple
                        filter
                        className="w-full"
                        showClear
                        max={2}
                        touched={true}
                        error={erros.auxiliares === true ? "Auxiliar Vinculado em Outra Carga" : null}
                        filterBy="nome,codigo"
                    />
                </div>
                <div className="md:col-span-3">
                    <Input
                        label="Área"
                        value={form.area}
                        onChange={e => setCampo("area", e.target.value)}
                    />
                </div>
       

                <div className="col-span-3">
                    <div className="flex flex-col">
                        <label
                            className={`text-sm font-medium text-foreground`}>
                            Tipo de Rota
                        </label>
                    </div>

                    <div className="flex items-center gap-3">
                        <ButtonRadio
                            label="24 Horas"
                            checked={form.tipoRota === "DIARIA"}
                            onChange={e => setCampo("tipoRota", "DIARIA")}
                        />
                        <ButtonRadio
                            label="48 Horas"
                            checked={form.tipoRota === "DOIS_DIAS"}
                            onChange={e => setCampo("tipoRota", "DOIS_DIAS")}
                        />
                        <ButtonRadio
                            label="AS+"
                            checked={form.tipoRota === "AS"}
                            onChange={e => setCampo("tipoRota", "AS")}
                        />
                        <ButtonRadio
                            label="Recarga"
                            checked={form.tipoRota === "RECARGA"}
                            onChange={e => setCampo("tipoRota", "RECARGA")}
                        />
                        <ButtonRadio
                            label="Frete"
                            checked={form.tipoRota === "FRETE"}
                            onChange={e => setCampo("tipoRota", "FRETE")}
                        />
                        <ButtonRadio
                            label="Reprogramação"
                            checked={form.tipoRota === "REPROGRAMACAO"}
                            onChange={e => setCampo("tipoRota", "REPROGRAMACAO")}
                        />
                    </div>

                </div>
                <div className="col-span-6">
                    <Textarea
                        label="Observação"
                        rows={1}
                        value={form.observacao || ""}
                        onChange={e => setCampo("observacao", e.target.value)}
                    />
                </div>
            </div>

            {/* Botões */}
            <div className="flex justify-between border-t border-border">
                <div className="flex justify-end gap-3 items-end pt-3">

                    <Button
                        label="Excluir"
                        variant="white"
                        onClick={() => setShowDialogDelete(true)}
                        iconLeft="fa fa-times"
                    />

                    <Button
                        label="Alterar data"
                        variant="white"
                        onClick={abrirAlterarData}
                        iconLeft="fa fa-calendar"
                    />

                </div>
                <div className="flex justify-end gap-3 items-end pt-1">
                    <Button
                        label="Cancelar"
                        variant="gray"
                        onClick={onClose}
                        iconLeft="fa fa-arrow-left"
                    />

                    <Button
                        label="Salvar"
                        variant="indigo"
                        loading={loading}
                        onClick={handleSalvar}
                        iconLeft="fa fa-save"
                    />
                </div>
            </div>

            <Dialog header={`Alterar data de operação da Carga ${carga?.carga}`}
                visible={showDialogData}
                onHide={() => setShowDialogData(false)}
                blockScroll
                className="w-[95%] max-w-md"
            >
                <div className="flex flex-col gap-3 pt-2">
                    <Input
                        label="Nova data de operação"
                        type="date"
                        value={novaDataOperacao}
                        onChange={(e) => setNovaDataOperacao(e.target.value)}
                    />
                    <span className="text-xs text-muted-foreground">
                        Só o dia da escala muda. Não é possível se a comissão da competência estiver fechada para quem está na escala.
                    </span>
                </div>

                <div className="flex justify-end gap-3 items-end pt-3">
                    <Button
                        label="Cancelar"
                        variant="gray"
                        onClick={() => setShowDialogData(false)}
                        iconLeft="fa fa-arrow-left"
                    />
                    <Button
                        label="Alterar data"
                        variant="indigo"
                        loading={salvandoData}
                        onClick={confirmarAlteracaoData}
                        iconLeft="fa fa-save"
                    />
                </div>
            </Dialog>

            <Dialog header={`Confirmação de exclusão da Carga ${carga?.carga}`}
                visible={showDialogDelete}
                onHide={onCloseModalDelete}
                blockScroll
                className="max-w-[60vw]"
            >
                <label className="text-muted-foreground pt-3 text-sm">
                    Para confirmar a exclusão desta carga, digite <strong>{carga?.carga}</strong> no campo abaixo e finalize a ação.
                </label>
                <Input
                    value={textoParaExcluir}
                    onChange={(e) => setTextoParaExcluir(e.target.value)}
                    placeholder={`Digite o texto '${carga.carga}' aqui`}
                />

                <div className="flex justify-end gap-3 items-end pt-3">
                    <Button
                        label="Cancelar"
                        variant="gray"
                        onClick={onCloseModalDelete}
                        iconLeft="fa fa-arrow-left"
                    />

                    <Button
                        label="Confirmar Exclusão"
                        variant="red"
                        loading={loading}
                        onClick={excluirCarga}
                        iconLeft="fa fa-times"
                        disabled={(carga?.carga !== textoParaExcluir?.trim()) && (carga?.carga !== null)}
                    />
                </div>

            </Dialog>
        </div>
    );
}

export default EditarEscalaRota;
